import React, {useRef, useState} from 'react';
import {Button} from "@mui/material";
import {Rest} from "../util/rest";
import {toast} from "react-toastify";

const ExcelSurveyUpload = ({assessment, user, onUploaded}) => {
    const inputRef = useRef(null);
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadAssessment, setUploadAssessment] = useState(null);
    const [errors, setErrors] = useState([]);

    const ensureUploadAssessment = async () => {
        if(assessment.assignmentType !== "ANONYMOUS") {
            return assessment;
        }
        if(uploadAssessment) {
            return uploadAssessment;
        }
        const cloned = await Rest.authFetch(user, `/rest/assessments/batch/clone/${assessment.id}`);
        setUploadAssessment(cloned);
        return cloned;
    }

    const handleUpload = async () => {
        if(!file) {
            toast.error("Please select an Excel file");
            return;
        }

        setUploading(true);
        setErrors([]);
        try {
            const targetAssessment = await ensureUploadAssessment();
            const formData = new FormData();
            formData.append("file", file);
            const response = await Rest.authFetchFormData(user, `/rest/assessment/${targetAssessment.id}/excel-upload`, {
                method: "POST",
                body: formData
            });
            toast.success("Assessment submitted");
            if(onUploaded) {
                onUploaded(response, targetAssessment);
            }
        }
        catch(error) {
            setErrors(error?.errors || [{message: error?.message || "Unable to upload this file"}]);
        }
        finally {
            setUploading(false);
        }
    }

    return (
            <div className="excel-upload col-12 text-center">
                <input
                        ref={inputRef}
                        type="file"
                        accept=".xls,.xlsx,.xlsm,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12"
                        style={{display: "none"}}
                        onChange={(event) => setFile(event.target.files?.[0] || null)}
                />
                <div className="row">
                    <div className="col-12 text-center">
                        <Button variant="outlined"
                                className="assessment-button"
                                onClick={() => inputRef.current?.click()}
                                disabled={uploading}>
                            {file ? file.name : "SELECT EXCEL FILE"}
                        </Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-center">
                        <Button variant="contained"
                                className="assessment-button"
                                onClick={handleUpload}
                                disabled={uploading || !file}>
                            {uploading ? "UPLOADING" : "UPLOAD"}
                        </Button>
                    </div>
                </div>
                {errors.length > 0 && (
                        <div className="row my-auto">
                            <div className="col-12">
                                <div className="excel-upload-errors" role="alert">
                                    <div className="excel-upload-errors-title">Upload could not be completed</div>
                                    <ul>
                                        {errors.map((error, index) => {
                                            const context = [error.cell, error.code].filter(Boolean).join(" / ");
                                            return (
                                                    <li key={index}>
                                                        {context && <span className="excel-upload-error-context">{context}</span>}
                                                        <span>{error.message}</span>
                                                    </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                )}
            </div>
    );
}

export default ExcelSurveyUpload;
